export default "__VITE_ASSET__D4FHHH9___"